module.exports = __webpack_public_path__ + "img/dust-mite-free.4e7705a.svg";